"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorRemoveDriverPriceWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualMotorRemoveDriverPriceWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorRemoveDriverPriceWidget, _super);
    function AnnualMotorRemoveDriverPriceWidget(props) {
        return _super.call(this, props) || this;
    }
    AnnualMotorRemoveDriverPriceWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null, this.renderOutputPanel()));
    };
    AnnualMotorRemoveDriverPriceWidget.prototype.renderOutputPanel = function () {
        var interaction = this.props.engine.getInteraction();
        var returnPremium = interaction.factors.returnPremium;
        var refundRequired = returnPremium > 0;
        var tierChangeWording = (0, commonFunctions_1.getTierChangeWording)(interaction);
        return (React.createElement(React.Fragment, null, refundRequired ? React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement("span", { className: "font-weight-bold" }, "refund"),
                " for removing ",
                interaction.uistate.removedDriverFullName,
                " from your car policy ",
                tierChangeWording,
                " The refund excludes the cost of your cover prior to the remove driver date."),
            interaction.uistate.renewalWindow && React.createElement("div", null,
                React.createElement("p", { className: "font-weight-semi-bold mb-0" },
                    "This means your next year's renewal price will be \u00A3",
                    interaction.uistate.totalRenewalAmount)),
            React.createElement("div", null, "All figures include Insurance Premium Tax")) : React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement("span", { className: "font-weight-bold" }, "additional premium"),
                " to remove ",
                interaction.uistate.removedDriverFullName,
                " from your car policy ",
                tierChangeWording),
            interaction.uistate.renewalWindow && React.createElement("p", { className: "font-weight-semi-bold mb-0" },
                "This means your next year's renewal price will be \u00A3",
                interaction.uistate.totalRenewalAmount),
            React.createElement("p", { className: "m-0 font-weight-extra-light fs-14" }, "All figures include Insurance Premium Tax"))));
    };
    return AnnualMotorRemoveDriverPriceWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualMotorRemoveDriverPriceWidget = AnnualMotorRemoveDriverPriceWidget;
//# sourceMappingURL=AnnualMotorRemoveDriverPriceWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AnnualMotorRemoveDriverPriceWidget.js
// module id = 3243
// module chunks = 0